export function viewMultiplier(data, multiplier) {
  let newData = [];

  for (let index = 0; index < data.length; index++) {
    const element = data[index];

    if (multiplier.includes(1) && !element.multiplier) {
      newData.push(element);
      continue;
    }

    if (multiplier.includes(element.multiplier)) {
      newData.push(element);
      continue;
    }
  }

  return [...newData];
}
